import React from "react";
import "./shell.css";

function getDaypart(hour: number): string {
  if (hour < 12) return "Good morning";
  if (hour < 18) return "Good afternoon";
  return "Good evening";
}

function getDisplayName(firstName: string | null): string | null {
  const trimmed = firstName?.trim();
  if (!trimmed) return null;
  return trimmed.split(/\s+/)[0] ?? null;
}

export type T_ShellHomeWelcomeProps = {
  /** Server-resolved browser-local hour; null keeps the stable generic fallback. */
  hour: number | null;
  firstName: string | null;
};

/** Desktop-only home-page hierarchy. Shared kit primitives remain cross-platform;
 * this page-level composition intentionally does not mirror the mobile shell. */
export function ShellHomeWelcome({ firstName, hour }: T_ShellHomeWelcomeProps) {
  const salutation = hour === null ? "Welcome back" : getDaypart(hour);
  const displayName = getDisplayName(firstName);

  return (
    <h1 className="shell-home__greeting">
      {salutation}
      {displayName ? `, ${displayName}` : ""}
    </h1>
  );
}
